import { Grid, Link, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./TrackProgress.scss";
import { CollapseRowProps } from "../../models/Workflow";
import { useTranslation } from "react-i18next";

export const TrackProgress = (props: CollapseRowProps) => {
  const { t } = useTranslation();
  return (
    <div className="track-progress px-5 py-4">
      <Grid container>
        <Grid item xs={6} md={6}>
          <Typography variant="h6" className="mb-3">
           {t("opva.trackProgress")}
          </Typography>
        </Grid>
        <Grid item xs={6} md={6}>
          <Link
            component="button"
            className="float-end"
            title="Close"
            onClick={props.collapseClose}
          >
            <CloseIcon />
          </Link>
        </Grid>
      </Grid>
    </div>
  );
};
